module.exports = __webpack_public_path__ + "0cfe5caa6b730679786833d590ab22de.png";